enum TourActions {
  Open = 0,
  Close = 1,
}

export default TourActions
